import { Power1, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const pan: gsapTimelineFunc = (target) => {
  return gsap.timeline().fromTo(
    target,
    {
      duration: 0,
      opacity: 0,
      x: '-50%',
      ease: Power1.easeOut,
    },
    {
      duration: 1,
      opacity: 1,
      x: 0,
      ease: 'power2.out',
    }
  );
};
